__turbopack_context__.v({
  "bullet-separation": "review-title-module-scss-module__tvuc4q__bullet-separation",
  "review-title": "review-title-module-scss-module__tvuc4q__review-title",
});
